
  jQuery(document).ready(function(){
    setTimeout(function(){
      if(!jQuery('body').hasClass('layout_rtl') && !jQuery('.productView-nav').hasClass('slick-slider')){
        console.log('attempt 1');
        jQuery('.productView-nav').slick({fade:true});
      } else{
        console.log('already there');
      }

      if(!jQuery('.customer-review__item').hasClass('slick-slider')){
       // jQuery('.customer-review__item').slick();
      }
    }, 4000);
    setTimeout(function(){
      if(!jQuery('body').hasClass('layout_rtl') && !jQuery('.productView-nav').hasClass('slick-slider')){
        console.log('attempt 1');
        jQuery('.productView-nav').slick({fade:true});
      } else{
        console.log('already there');
      }

      if(!jQuery('.customer-review__item').hasClass('slick-slider')){
       // jQuery('.customer-review__item').slick();
      }
    }, 6000);
    setTimeout(function(){
      if(!jQuery('body').hasClass('layout_rtl') && !jQuery('.productView-nav').hasClass('slick-slider')){
        console.log('attempt 2');
        jQuery('.productView-nav').slick({fade:true});
      } else{
        console.log('already there');
      }

      if(!jQuery('.customer-review__item').hasClass('slick-slider')){
       // jQuery('.customer-review__item').slick();
      }
    }, 8000); 
    setTimeout(function(){
          if(!jQuery('body').hasClass('layout_rtl') && !jQuery('.productView-nav').hasClass('slick-slider')){
            console.log('attempt 3');
            jQuery('.productView-nav').slick({fade:true});
          }

        if(!jQuery('.customer-review__item').hasClass('slick-slider')){
           // jQuery('.customer-review__item').slick();
        }
    }, 10000);
    
    jQuery('.condition-guide-btn-eng').click(function() {
      jQuery('.modal-condition-guide-eng').css('opacity', '1');
      jQuery('.modal-condition-guide-eng').css('visibility', 'visible');
      jQuery('.modal-condition-guide-eng').css('display', 'flex');
    });

    jQuery('.condition-guide-btn-ar').click(function() {
      jQuery('.modal-condition-guide-ar').css('opacity', '1');
      jQuery('.modal-condition-guide-ar').css('visibility', 'visible');
      jQuery('.modal-condition-guide-ar').css('display', 'flex');
    });
    
    jQuery('body.layout_rtl .colbannerlink a').attr("href", "#.");

    jQuery('body.layout_rtl .colbannerlink a').click(function() {
      jQuery('.learn-more-arabic-popup').css('opacity', '1');
      jQuery('.learn-more-arabic-popup').css('visibility', 'visible');
      jQuery('.learn-more-arabic-popup').css('display', 'flex');
    });

    jQuery('.modal .close-button').click(function() {
      jQuery('.modal').css('opacity', '0');
      jQuery('.modal').css('visibility', 'hidden');
      jQuery('.modal').css('display', 'none');
    });

    window.onclick = function(event) {
       if (event.target.id != "image_in_modal_div") {
          $("#modal_div").hide();
       }
    }

  /*Added by Ali Hanif for product image height adjustment */
    if(jQuery(window).width() > 767)
    {
      jQuery('.productView-image .productView-img-container').css({'max-height': '450px', 'top': '-85px'});
    }
    jQuery('.field__currency').html('PKR');
    
    /*Code by Ali for add to cart variant change*/
    jQuery('form.installment input[name="id"]').change(function(){

      jQuery('form.main_product_add_to_cart_form').find('input[name="id"]').val(jQuery(this).val()); 
      var product_id = jQuery('.product-form__input .product-form__label').attr('for').split("-")[1];
      var current_variant_id = jQuery(this).val();
      var all_variants_quantities = eval('product_inven_array_'+product_id);
      console.log(current_variant_id);
      jQuery.map( all_variants_quantities, function( variant_quantity, variant_id ) {
        if(variant_id==current_variant_id){
            current_variant_quantity = variant_quantity;
            console.log(current_variant_quantity);
        }
      });

        if(parseInt(current_variant_quantity==0) || current_variant_quantity=='0'){ 
        jQuery('#product-sticky-add-to-cart').attr('disabled',true);
        jQuery('#product-sticky-add-to-cart').html('Sold Out');
        setTimeout(function(){
          jQuery('.product-form__radio[name="Storage"]:checked+.product-form__label').addClass('soldout');
          jQuery('.product-form__radio[name="Condition"]:checked+.product-form__label').addClass('soldout');
        }, 500);
      } else {
          jQuery('#product-sticky-add-to-cart').attr('disabled',false);
          jQuery('#product-sticky-add-to-cart').html('Shop Now');
          jQuery('body.layout_rtl #product-sticky-add-to-cart').html('اشتري الآن');
          
          setTimeout(function(){
            jQuery('.product-form__radio:checked+.product-form__label').removeClass('soldout'); 
        }, 500);
      }
      
    });
    /*Code by Ali for media change on variant change or product load*/
    /*function change_variant_media(media_id){
      console.log(media_id);
      var hittedIndex = 2;
      if(media_id){
        jQuery('.productView-image').removeClass('slick-current slick-active');//.css('opacity',0);
        jQuery('.revibe-media-'+media_id).addClass('slick-current slick-active').css('opacity',1);//.prependTo(".slick-track");
        //jQuery('.slick-slider').slick('slickGoTo', hittedIndex);
      }
    }*/
    setTimeout(function(){
      jQuery('.product-form__swatch .product-form__radio:checked+.product-form__label[name="Color"]').trigger('click');
    }, 4000);
   
    jQuery('.product-form__input .product-form__label').click(function(){
        if(jQuery(this).attr('name')=='Color'){
          var media_id = jQuery(this).data('variant-media');
          var hittedIndex = jQuery('.revibe-media-'+media_id).data('slick-index');
          jQuery('.slick-slider').slick('slickGoTo', hittedIndex);
          //change_variant_media(media_id);
        }
    });
    
  });

jQuery(document).ready(function(){
jQuery('#tabs-nav li:first-child').addClass('active');
jQuery('.tabcontent').hide();
jQuery('.tabcontent.active').show();

// Click function
jQuery('#tabs-nav li').click(function(){
  jQuery('#tabs-nav li').removeClass('active');
  jQuery(this).addClass('active');
  jQuery('.tabcontent').hide();
  
  var activeTab = jQuery(this).find('a').attr('href');
  jQuery(activeTab).fadeIn();
  return false;
});

});










  // Set the target date
  const targetDate = new Date("July 25, 2028 23:59:00").getTime();

  // Function to update the countdown
function updateCountdown() {
  const now = new Date().getTime();
  const distance = targetDate - now;

  // Calculate time units
  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

  // Pad with leading zero
  const paddedDays = days < 10 ? "0" + days : days;
  const paddedHours = hours < 10 ? "0" + hours : hours;
  const paddedMinutes = minutes < 10 ? "0" + minutes : minutes;

  // Safely update the HTML if elements are found
  const daysEl = document.getElementById("days");
  const hoursEl = document.getElementById("hours");
  const minutesEl = document.getElementById("minutes");

  if (daysEl) daysEl.innerHTML = paddedDays;
  if (hoursEl) hoursEl.innerHTML = paddedHours;
  if (minutesEl) minutesEl.innerHTML = paddedMinutes;

  // If countdown is over
  if (distance < 0) {
    clearInterval(countdownInterval);
    if (daysEl) daysEl.innerHTML = "00";
    if (hoursEl) hoursEl.innerHTML = "00";
    if (minutesEl) minutesEl.innerHTML = "00";
    alert("Countdown has ended!");
  }
}

  // Update the countdown every minute (60000ms)
  const countdownInterval = setInterval(updateCountdown, 60000);

  // Initial call to display the countdown immediately
  updateCountdown();


        let lastScrollTop = 0;
        const header = document.getElementById("shopify-section-header-05");

        window.addEventListener("scroll", function () {
            let scrollTop = window.scrollY || document.documentElement.scrollTop;

            if (scrollTop < lastScrollTop) {
                header.classList.add("fixed-header");
                header.classList.remove("fixed-removed");
            } else {
              header.classList.remove("fixed-header");
                header.classList.add("fixed-removed");
            }

          // Remove fixed position when scrolling back to 36px from the top
    if (scrollTop <= 36) {
        header.classList.remove("fixed-header");
    }

            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        });






  // Change the main image and add 'active' class to the clicked thumbnail
          function changeMainImage(thumbnailElement) {
            const mainImage = document.getElementById('main-product-image');
            const thumbnails = document.querySelectorAll('.thumbnail img');
            const fullImageUrl = thumbnailElement.querySelector('img').getAttribute('data-full-image');

            // Update the main image source
            mainImage.src = fullImageUrl;

            // Remove 'active' class from all thumbnails
            thumbnails.forEach(thumbnail => thumbnail.parentElement.classList.remove('active'));

            // Add 'active' class to the clicked thumbnail
            thumbnailElement.classList.add('active');
          }



function setVariantImageById(variantId) {
  if (!window.bcpo_product || !bcpo_product.variants) {
    console.log("bcpo_product.variants not found");
    return null;
  }

  const variant = bcpo_product.variants.find(v => v.id == variantId);
  console.log("Variant Is", variant);

  setPricesOfVariant(variant);

  if (!variant) return null;

var variantQty = variant.inventory_quantity;
    var addToCartButton = document.getElementById("product-sticky-add-to-cart");

if (variantQty < 1) {
    addToCartButton.disabled = true;
    addToCartButton.textContent = "Sold out";
  } else {
    addToCartButton.disabled = false;
    addToCartButton.textContent = "Add To Bag";
  }

  
  let ccLname = variant.color_name;
  if(!ccLname)
  {
    ccLname = variant.title;
  }
  const selectedColorDiv = document.getElementById('selectedColorDiv');
  const idInputproperty = document.querySelector('#colorNameProperty');

  if (selectedColorDiv) {
    selectedColorDiv.innerHTML = ccLname;
  }

  if (idInputproperty) {
    idInputproperty.value = ccLname;
  }

  if (variant.featured_image && variant.featured_image.src) {
    // Shopify CDN optimization (resize image to improve loading)
    const optimizedSrc = variant.featured_image.src + '&width=600';

    // Update main image
    const mainImage = document.querySelector('.zoomable-image');
    if (mainImage) {
      mainImage.style.visibility = 'hidden';
      mainImage.src = optimizedSrc;
      mainImage.onload = () => {
        mainImage.style.visibility = 'visible';
      };
    }

    // Update product image by ID
    const productImage = document.getElementById('main-product-image');
    if (productImage) {
      productImage.style.visibility = 'hidden';
      productImage.src = optimizedSrc;
      productImage.onload = () => {
        productImage.style.visibility = 'visible';
      };
    }

    // Normalize image URL for matching thumbnails
    const targetSrc = normalizeShopifyImageUrl(variant.featured_image.src);

    // Highlight the correct thumbnail
    document.querySelectorAll('.thumbnail-gallery > div').forEach(div => {
      const img = div.querySelector('img');
      if (!img) return;

      const thumbSrc = img.getAttribute('data-full-image') || img.getAttribute('src');
      const normalizedThumbSrc = normalizeShopifyImageUrl(thumbSrc);

      div.classList.toggle('active', normalizedThumbSrc === targetSrc);
    });

    return variant.featured_image.src;
  } else {
    console.warn(`No image found for variant ID: ${variantId}`);
    return null;
  }
}



function normalizeShopifyImageUrl(url) {
  if (!url) return '';
  // Remove query params
  let cleanUrl = url.split('?')[0];

  // Remove Shopify size suffixes like _200x200, _400x, etc. before the file extension
  cleanUrl = cleanUrl.replace(/(_\d+x\d+|_\d+x|_x\d+)?(\.\w{3,4})$/, '$2');

  return cleanUrl;
}



document.addEventListener('DOMContentLoaded', function () {
const radios = document.querySelectorAll('.product-form__radio');

radios.forEach(radio => {
radio.addEventListener('change', function () {
var selectedValue = this.value.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-_]/g, '');

var selectedVariantId = this.getAttribute('data-variant-id');



// 1. Update input[name="id"] value with variant ID
var idInputs = document.querySelectorAll('input[name="id"]');
var idInputproperty = document.querySelector('#colorNameProperty');
var selectedColorDiv = document.querySelector('#selectedColorDiv');


idInputproperty.value =  selectedColorDiv.innerHTML.trim();

idInputs.forEach(input => {
input.value = selectedVariantId;
});

setVariantImageById(selectedVariantId);
// 2. Hide all thumbnails
var thumbnails = document.querySelectorAll('.thumbnail');
thumbnails.forEach(thumb => {
thumb.style.display = 'none';
});

// 3. Show matching thumbnails using class contains attribute
var filteredThumbs = Array.from(thumbnails).filter(thumb => {
return thumb.classList.contains(selectedValue);
});

filteredThumbs.forEach(thumb => {
thumb.style.display = 'block';
});
var variant = getSelectedVariant();

var variantBackground = variant.background;
//var colors = ['#fef7f2', '#e0f7fa', '#fce4ec', '#f3e5f5', '#ede7f6', '#e8f5e9', '#fff3e0', '#f9fbe7', '#e1f5fe', '#fbe9e7', '#e0f2f1', '#f1f8e9'];
  var colors = ['#d9d9d9'];

var bgColor = variantBackground || colors[Math.floor(Math.random() * colors.length)];
var bgColor = '#d9d9d9';

  
  console.log("My Variant Background Must Be",bgColor);
document.querySelectorAll('.product-details').forEach(function(el) {
el.style.background = bgColor;
});
});
});
});


document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.includes('/products/')) return;

  setTimeout(() => {
    const urlVariantId = new URLSearchParams(window.location.search).get('variant');
    let labelToClick = null;

    if (urlVariantId) {
      const matchingRadio = document.querySelector('.product-form__radio[data-variant-id="' + urlVariantId + '"]');
      if (matchingRadio && matchingRadio.nextElementSibling && matchingRadio.nextElementSibling.classList.contains('product-form__label')) {
        labelToClick = matchingRadio.nextElementSibling;
      }
    }

    // fall back to first available only when there's no (matching) variant in the URL
    if (!labelToClick) {
      labelToClick = document.querySelector('.product-form__label.available');
    }

    if (labelToClick) {
      labelToClick.click();
    }

      var idInputproperty = document.querySelector('#colorNameProperty');
  var selectedColorDiv = document.querySelector('#selectedColorDiv');

  
  idInputproperty.value =  selectedColorDiv.innerHTML.trim();
  const variant = getSelectedVariant();
  const targetSrc = normalizeShopifyImageUrl(variant.featured_image.src);

document.querySelectorAll('.thumbnail-gallery > div').forEach(div => {
    const img = div.querySelector('img');
    if (!img) return;

    const thumbSrc = img.getAttribute('data-full-image') || img.getAttribute('src');
    const normalizedThumbSrc = normalizeShopifyImageUrl(thumbSrc);

    if (normalizedThumbSrc === targetSrc) {
      div.classList.add('active');
    } else {
      div.classList.remove('active');
    }
  });


  var variantBackground = variant.background;
//var colors = ['#fef7f2', '#e0f7fa', '#fce4ec', '#f3e5f5', '#ede7f6', '#e8f5e9', '#fff3e0', '#f9fbe7', '#e1f5fe', '#fbe9e7', '#e0f2f1', '#f1f8e9'];
  var colors = ['#d9d9d9'];

var bgColor = variantBackground || colors[Math.floor(Math.random() * colors.length)];
var bgColor = '#d9d9d9';
document.querySelector('.product-details').style.background = bgColor;


    
  }, 1000);
});


function getSelectedVariant() {
  const selectedId = document.querySelector('input[name="id"]')?.value;
  if (!selectedId) return null;

  return bcpo_product.variants.find(v => String(v.id) === String(selectedId));
}


document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.includes('/products/')) return;

  const thumbnails = document.querySelectorAll('.thumbnail');

  let checkedColour = document.querySelector('input[name="colour"]:checked') ||
                      document.querySelector('input[name="Color Code"]:checked') ||
                      document.querySelector('input[name="Color"]:checked') ||
                      document.querySelector('input[name="Size"]:checked');

  const variant = getSelectedVariant();
   setPricesOfVariant(variant);

  // Always prepare target image and background, regardless of color
  const targetSrc = normalizeShopifyImageUrl(variant.featured_image?.src || '');



  var variantBackground = variant.background;
//var colors = ['#fef7f2', '#e0f7fa', '#fce4ec', '#f3e5f5', '#ede7f6', '#e8f5e9', '#fff3e0', '#f9fbe7', '#e1f5fe', '#fbe9e7', '#e0f2f1', '#f1f8e9'];
  var colors = ['#d9d9d9'];

var bgColor = variantBackground || colors[Math.floor(Math.random() * colors.length)];
var bgColor = '#d9d9d9';
document.querySelector('.product-details').style.background = bgColor;


  

  // If no color is selected, just show all thumbnails
  if (!checkedColour) {
    thumbnails.forEach(thumb => {
      thumb.style.display = 'block';
      thumb.classList.remove('active');
    });
  } else {
    // Normalize selected value
    const selectedValue = checkedColour.value.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-_]/g, '');
    console.log("Normalized selected colour value:", selectedValue);

    let matchedAny = false;

    thumbnails.forEach(thumb => {
      thumb.classList.remove('active');
      if (thumb.classList.contains(selectedValue)) {
        thumb.style.display = 'block';
        matchedAny = true;
      } else {
        thumb.style.display = 'none';
      }
    });

    // Fallback: If no thumbnails matched, show all to avoid showing none
    if (!matchedAny) {
      console.warn("No thumbnails matched. Falling back to show all.");
      thumbnails.forEach(thumb => thumb.style.display = 'block');
    }
  }

  // Highlight active thumbnail
  document.querySelectorAll('.thumbnail-gallery > div').forEach(div => {
    const img = div.querySelector('img');
    if (!img) return;

    const thumbSrc = img.getAttribute('data-full-image') || img.getAttribute('src');
    const normalizedThumbSrc = normalizeShopifyImageUrl(thumbSrc);

    if (normalizedThumbSrc === targetSrc) {
      div.classList.add('active');
    } else {
      div.classList.remove('active');
    }
  });
});




  function updateRichTextClass(tabElement) {
    const tabName = tabElement.textContent.trim();
    const tabKey = tabName.toLowerCase();
  
    const richTextSection = document.querySelector('.rich-text.section-block-template--23723449483556__rich_text_BDGemU');
    const richTextTitle = document.querySelector('.rich-text__sub p');
  
    if (richTextSection) {
      richTextSection.classList.remove('winter-style', 'spring-style', 'summer-style', 'fall-style');
  
      if (['winter', 'spring', 'summer', 'fall'].includes(tabKey)) {
        richTextSection.classList.add(`${tabKey}-style`);
      }
    }
  
    // Update the sub-heading text
    if (richTextTitle) {
      richTextTitle.textContent = tabName;
    }
  }


  document.addEventListener('DOMContentLoaded', () => {
    const tabLinks = document.querySelectorAll('.tab-links');

    // Set initial class based on the first active tab
    const initialTab = document.querySelector('.tab-links.active') || tabLinks[0];
    if (initialTab) {
      updateRichTextClass(initialTab);
    }

    // Add click event listeners
    tabLinks.forEach(link => {
      link.addEventListener('click', function () {
        updateRichTextClass(this);

        // Optional: update active state visually
        tabLinks.forEach(el => el.classList.remove('active'));
        this.classList.add('active');
      });
    });
  });

const mainImageContainer = document.querySelector('.main-image');

if (mainImageContainer) {
  const observer = new MutationObserver(() => {
    if (mainImageContainer.style.display === 'none') {
      mainImageContainer.style.display = 'inline-block';
    }
  });

  observer.observe(mainImageContainer, {
    attributes: true,
    attributeFilter: ['style'],
  });
}

 const tabs = document.querySelectorAll('.tab-collection-tabs-section');
  if (tabs.length > 0) {
    let currentTabIndex = 0;

    function autoplayTabsCollectionTabsSection() {
      tabs[currentTabIndex].click(); // Trigger existing onclick
      currentTabIndex = (currentTabIndex + 1) % tabs.length;
    }

    let tabInterval = setInterval(autoplayTabsCollectionTabsSection, 5000);

    // Optional: pause on hover
    const tabContainer = document.querySelector('.tabs-collection-tabs-section');
    tabContainer.addEventListener('mouseenter', () => clearInterval(tabInterval));
    tabContainer.addEventListener('mouseleave', () => {
      tabInterval = setInterval(autoplayTabsCollectionTabsSection, 5000);
    });
  }


  function setPricesOfVariant(variant)
  {
    console.log("Variant",variant);

    const compareDiv = document.querySelector(".compare-price-div");
  const normalDiv = document.querySelector(".normal-price");

  if (compareDiv) {
    compareDiv.textContent = variant.compare_at_with_currency || "";
    if (variant.compare_at_price <= variant.price) {
      compareDiv.classList.add("invisible");
    } else {
      compareDiv.classList.remove("invisible");
    }
  }

  if (normalDiv) {
    normalDiv.textContent = variant.normal_price_with_currency || "";
  }
  }




  function changeMainImage(thumbnailElement) {
    const wrapper = document.getElementById('main-product-media-wrapper');
    const thumbnails = document.querySelectorAll('.thumbnail-gallery .thumbnail');

    if (!wrapper) return;

    thumbnails.forEach(function (thumb) {
      thumb.classList.remove('active');
    });

    thumbnailElement.classList.add('active');

    const mediaType = thumbnailElement.getAttribute('data-media-type');

    if (mediaType === 'image') {
      const img = thumbnailElement.querySelector('img');
      const fullImageUrl = img ? img.getAttribute('data-full-image') : '';

      if (fullImageUrl) {
        wrapper.innerHTML = `
          <img
            id="main-product-image"
            src="${fullImageUrl}"
            alt="${img.getAttribute('alt') || ''}"
            class="zoomable-image"
            data-media-type="image"
          >
        `;
      }
    }

    if (mediaType === 'video') {
      const sources = thumbnailElement.querySelectorAll('.video-source');
      let videoSourcesHtml = '';

      sources.forEach(function (source) {
        const src = source.getAttribute('data-src');
        const type = source.getAttribute('data-type');
        if (src) {
          videoSourcesHtml += `<source src="${src}" type="${type || 'video/mp4'}">`;
        }
      });

      wrapper.innerHTML = `
        <video
          id="main-product-video"
          class="main-product-video"
          controls
          autoplay
          playsinline
          preload="metadata"
        >
          ${videoSourcesHtml}
          Your browser does not support the video tag.
        </video>
      `;
    }

    if (mediaType === 'external_video') {
      const embedHtml = thumbnailElement.getAttribute('data-embed-html');

      if (embedHtml) {
        wrapper.innerHTML = `
          <div id="main-product-external-video" class="main-product-external-video">
            ${embedHtml}
          </div>
        `;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const firstVisibleThumb = document.querySelector('.thumbnail-gallery .thumbnail:not([style*="display:none"])');
    if (firstVisibleThumb) {
      firstVisibleThumb.classList.add('active');
    }
  });
